<div class="flex flex-col w-full h-full">
  <div class="flex flex-row gap-4 justify-between mb-8">
    <h1 class="text-light-300 text-3xl font-medium">
      Cart @if(!isLoading && cart.length){({{ cart.length }})}
      <span class="text-xl text-red-100">(Demo Mode)</span>
    </h1>

    <p-button
      severity="primary"
      variant="outlined"
      (onClick)="onViewProperties()"
    >
      <svg-icon src="assets/icons/plus.svg" svgClass="h-4 w-4" />
      Add more
    </p-button>
  </div>

  @if (!isLoading) {
  <div class="flex flex-col lg:flex-row gap-6 pb-8">
    <!-- Properties to invest -->
    <form
      [formGroup]="form"
      class="flex flex-col flex-[3_1_0%] lg:flex-[2_1_0%] gap-6"
    >
      <div class="flex flex-col gap-6 w-full" formArrayName="amounts">
        @for (item of cart; track $index; let i = $index) {
        <p-card>
          <div class="flex flex-col gap-6">
            <div class="flex flex-col sm:flex-row gap-5">
              <img
                class="rounded-lg h-20 w-32 object-cover"
                [src]="item.property.images[0].url"
                [alt]="item.property.images[0].caption"
              />

              <div class="flex flex-row gap-3 w-full justify-between">
                <div class="flex flex-col gap-3">
                  <h2 class="font-bold text-base text-light-300">
                    {{ item.property.name }}
                  </h2>

                  <div class="flex flex-row gap-6">
                    <div
                      class="flex flex-row gap-1 items-center text-light-100"
                    >
                      <svg-icon
                        src="assets/icons/info.svg"
                        svgClass="h-4 w-4"
                        (click)="isTouchDevice && info.toggle($event)"
                        (mouseenter)="!isTouchDevice && info.show($event)"
                        (mouseleave)="!isTouchDevice && info.hide()"
                      />
                      <p class="font-medium text-sm">Monthly rent</p>

                      <p-popover #info>
                        <p class="w-56 text-light-0 text-base">
                          The total value of your pending investments, cash
                          balance, and all of your Properties (based on the
                          latest valuation of the properties)
                        </p>
                      </p-popover>
                    </div>

                    <p class="font-bold text-sm text-light-300">
                      {{ item.monthlyCashflow | customCurrency : currency }}
                    </p>
                  </div>

                  <div class="flex flex-row gap-6">
                    <div
                      class="flex flex-row gap-1 items-center text-light-100"
                    >
                      <svg-icon
                        src="assets/icons/info.svg"
                        svgClass="h-4 w-4"
                        (click)="isTouchDevice && appreciation.toggle($event)"
                        (mouseenter)="
                          !isTouchDevice && appreciation.show($event)
                        "
                        (mouseleave)="!isTouchDevice && appreciation.hide()"
                      />
                      <p class="font-medium text-sm">Appreciation</p>

                      <p-popover #appreciation>
                        <p class="w-56 text-light-0 text-base">
                          Capital appreciation projections are based based on a
                          5 year holding period
                        </p>
                      </p-popover>
                    </div>

                    <p class="font-bold text-sm text-light-300">
                      {{
                        item.property.appreciation | customCurrency : currency
                      }}
                    </p>
                  </div>
                </div>

                <p-button
                  variant="text"
                  severity="danger"
                  [style]="{
                    padding: '5px'
                  }"
                  (onClick)="onRemoveProperty(i)"
                >
                  <svg-icon
                    src="assets/icons/trash-bin.svg"
                    svgClass="h-4 w-4 cursor-pointer text-red-100"
                  />
                </p-button>
              </div>
            </div>

            <p-inputgroup class="h-12.5">
              <p-inputgroup-addon>
                <div class="flex flex-row items-center gap-1">
                  <!-- <svg-icon
                    [src]="
                      'assets/flags/' + item.property.country.icon + '.svg'
                    "
                    svgClass="h-4 w-4 text-light-100"
                  /> -->

                  <span class="font-semibold text-sm text-light-300">
                    {{ currency }}
                  </span>
                </div>
              </p-inputgroup-addon>
              <p-inputnumber
                [formControlName]="i"
                placeholder="Enter amount"
                (onInput)="onUpdateAmount(i, $event)"
              />
            </p-inputgroup>
          </div>
        </p-card>
        }
      </div>
    </form>

    <!-- Proceed to payment -->

    @if (cart.length) {
    <div class="flex-[2_1_0%] lg:flex-[1_1_0%]">
      <p-card styleClass="h-fit lg:min-w-0 sticky top-0">
        <div class="flex flex-col gap-4">
          <div
            class="flex flex-row gap-2 justify-between font-bold text-xl text-light-300"
          >
            <p>Total</p>
            <p>{{ totalPaymentAmount | customCurrency : currency }}</p>
          </div>

          <p-fluid>
            <p-button
              type="submit"
              label="Proceed to Payment"
              [fluid]="true"
              [disabled]="form.invalid"
              (onClick)="onProceedToPayment()"
            >
            </p-button>
          </p-fluid>
        </div>
      </p-card>
    </div>
    }
  </div>

  <!-- Show empty cart -->
  @if(!cart.length) {
  <ng-container *ngTemplateOutlet="emptyCart" />
  }

  <!-- Show loader -->
  } @else {
  <ng-container *ngTemplateOutlet="loadingSkeleton" />
  }
</div>

<ng-template #emptyCart>
  <div class="flex flex-col gap-6 w-full h-full items-center justify-center">
    <div
      class="flex flex-col items-center justify-center border-4 border-blue-300 w-24 h-24 rounded-full"
    >
      <svg-icon
        src="assets/icons/cart.svg"
        svgClass="h-14 w-14 text-blue-100"
      />
    </div>

    <h1 class="font-bold text-4xl text-light-300">Your cart is empty</h1>
    <p class="text-xl text-light-300 text-center">
      Looks like you haven’t added any properties in your cart
    </p>

    <p-button
      severity="primary"
      type="submit"
      label="View properties"
      size="large"
      (onClick)="onViewProperties()"
    />
  </div>
</ng-template>

<ng-template #loadingSkeleton>
  <div class="flex flex-col lg:flex-row gap-6">
    <div class="flex flex-col flex-[3_1_0%] lg:flex-[2_1_0%] gap-6">
      @for (_ of [1, 2, 3]; track $index) {
      <p-card>
        <div class="flex flex-row gap-5 mb-3">
          <p-skeleton height="80px" width="150px" />

          <div class="flex flex-col gap-3">
            <p-skeleton height="20px" width="250px" />

            <div class="flex flex-row gap-2">
              <div class="flex flex-col gap-1.5">
                <p-skeleton height="10px" width="100px" />
                <p-skeleton height="10px" width="70px" />
              </div>

              <div class="flex flex-col gap-1.5">
                <p-skeleton height="10px" width="100px" />
                <p-skeleton height="10px" width="70px" />
              </div>
            </div>
          </div>
        </div>

        <p-skeleton height="30px" width="100%" />
      </p-card>
      }
    </div>
    <div class="flex-[2_1_0%] lg:flex-[1_1_0%]">
      <p-card styleClass="min-w-[560px] lg:min-w-0">
        <p-skeleton height="100px" width="100%" />
      </p-card>
    </div>
  </div>
</ng-template>
